import I18n from "components/materials/I18n";
import useHead from "hooks/useHead";
import { ESubStep } from "common/enums/Subscription/ESubStep";
import SubscriptionsTable from "../elements/SubscriptionsTable";

export default function WaitingContrepartie() {
	useHead({
		title: `${I18n.asset.pages.subscriptions.page_title} - ${I18n.asset.pages.subscriptions.sub_pages.waiting_contrepartie.page_title}`,
	});

	return <SubscriptionsTable subSteps={[ESubStep.waiting_contrepartie]} dateLabel={I18n.asset.pages.subscriptions.sub_pages.waiting_contrepartie.date} />;
}
